import React, { useState } from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { routes } from '../../MainPage';
import PageBanner from '../../Components/Other/PageBanner'
import { useDispatch, useSelector } from 'react-redux';
import { CommonApiFun } from '../../Redux/Action/index'
function DoctorTeam(props) {
    let navigate = useNavigate();
    const dispatch = useDispatch()
    const [activeType, setActiveType] = useState("Doctors")
    var TeamArr1 = useSelector((state) => state.TeamArr)
    var Doctor = TeamArr1.filter((item) => item.role == "Doctor" || item.role == "Homoeopathy" || item.role == "physiotherapist" || item.role == "Senior Assistant" || item.role == "Assistant" || item.role == "Physiotherapist")
    var assistant = TeamArr1.filter((item) => item.role == "Receptionist")
    var Researcher = TeamArr1.filter((item) => item.role == "Researcher" || item.role == "Technology specialist")
    var TeamArr = activeType == "Doctors" ? Doctor : activeType == "assistant" ? assistant : Researcher
    TeamArr.length == 0 ? document.body.classList.add('loader-show') : document.body.classList.remove('loader-show');
    useEffect(() => {
        var data = { action: "team" }
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {

            dispatch({ type: 'TEAM_DATA', payload: res.data })

        }).catch((e) => {

        })
    }, [])
    return (
        <PageWrapper className={"doctors-team-pag"}>
            <div className="pageWrapper">
                <PageBanner pageName={"Our Doctors Team"}></PageBanner>
                <div className="MainContent">
                    <div className="container">
                        <div className="disease_wrap disease-grid">
                            <section className="tab__container">
                                <div className="tab__title">

                                    <button className={`tab__button ${activeType == "Doctors" && 'tab_button-active'}`} onClick={() => setActiveType('Doctors')}>
                                        Doctors
                                    </button>
                                    <button className={`tab__button ${activeType == "Researcher" && 'tab_button-active'}`} onClick={() => setActiveType('Researcher')}>
                                        Research Associate
                                    </button>
                                    <button className={`tab__button ${activeType == "assistant" && 'tab_button-active'}`} onClick={() => setActiveType('assistant')}>
                                        Front desk Assistant{" "}
                                    </button>
                                </div>
                                {TeamArr1.length == 0 && <div className='loader-box'><div className="loader"></div></div>}
                                <div className="row services_box">

                                    {TeamArr.map((item, index) => {
                                        var oldInd = TeamArr1.findIndex(i => item.email === i.email);


                                        return (<div className="col-mb-12 col-xs-6 col-md-4 col-3" key={index}>
                                            <div className="box-item" >
                                                <img src={item.profile_image} alt="team one" />
                                                <div className="hover">
                                                    <a
                                                        onClick={() => { navigate(routes.team + "/" + oldInd); }}
                                                        href={routes.team + "/" + oldInd}
                                                        className="link"
                                                    >
                                                        {item.lable}
                                                    </a>
                                                    <div className="info">

                                                        <ul className="listUnstyle">
                                                            <li>
                                                                <h5>{item.name}</h5>
                                                            </li>
                                                            <li>{item.role}</li>
                                                            <li >{item.qualifications}</li>
                                                        </ul>
                                                        <div className="social_ends">
                                                            <p><em></em></p>
                                                            {item.social_media !== "" && <div className="social">
                                                                {item.social_media.facebook && <a href={item.social_media.facebook} target="_blank">
                                                                    <i className="fab fa-facebook-f" />
                                                                </a>}
                                                                {item.social_media.instagram && <a href={item.social_media.instagram} target="_blank">
                                                                    <i className="fab fa-instagram" />
                                                                </a>}
                                                                {item.social_media.twitter && <a href={item.social_media.twitter} target="_blank">
                                                                    <i className="fab fa-twitter" />
                                                                </a>}
                                                            </div>}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>)
                                    }

                                    )}
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
}

export default DoctorTeam;